import { gql } from '@apollo/client';

export const SAVE_AUDIENCE = gql`
  mutation SaveAudience(
    $audienceName: String!
    $filters: String!
    $recordsIncluded: Int
  ) {
    saveAudience(
      audienceName: $audienceName
      filters: $filters
      recordsIncluded: $recordsIncluded
    )
  }
`;

/**
 * Re-runs the export + crawl pipeline for an audience whose preparation never
 * completed. Returns straight away — the export takes minutes, so the audience
 * comes back as "processing" and the caller's existing poll picks up
 * `crawledAt` when it lands.
 */
export const RETRY_AUDIENCE_CRAWL = gql`
  mutation RetryAudienceCrawl($audienceId: ID!) {
    retryAudienceCrawl(audienceId: $audienceId) {
      id
      name
      crawledAt
      crawlingFailed
      crawlRetryCount
      updatedAt
    }
  }
`;

export const UPDATE_RECORDS_INCLUDED = gql`
  mutation UpdateRecordsIncluded($audienceId: String!, $recordsIncluded: Int!) {
    updateRecordsIncluded(
      audienceId: $audienceId
      recordsIncluded: $recordsIncluded
    )
  }
`;
